
export default {"-1":"English (US)","-2":"French","-3":"German","-4":"Italian","-5":"Spanish","-6":"Brazilian Portuguese","-7":"Simplified Chinese","-8":"Traditional Chinese","-10":"Japanese","-20":"Russian","-21":"Romanian","-9":"Korean","-22":"Polish","-23":"Arabic"}
